//deps
import { useContext, useMemo } from "react";

//internal-deps
import { PAYLATER_TYPES } from "@swiggy-private/payment-types";

//context
import { ShowPaymentContext } from "@payment-client/contexts/ShowPaymentContext";

//helpers

//constant
import { findPayLaterPaymentMethod } from "@payment-client/helpers/PaylaterHelper";
import { PayLaterPaymentMethodData } from "@swiggy-private/payment-ui";

export interface GetLinkedPayLaterDetails {
    payLaterMethodData?: PayLaterPaymentMethodData;
}

export const useGetPayLaterData = (walletCode: PAYLATER_TYPES): GetLinkedPayLaterDetails => {
    const { paymentResponse } = useContext(ShowPaymentContext);

    const payLaterMethodData = useMemo<PayLaterPaymentMethodData | undefined>(() => {
        try {
            return findPayLaterPaymentMethod(paymentResponse?.paymentGroup || [], walletCode).unwrap();
        } catch {
            return undefined;
        }
    }, [paymentResponse?.paymentGroup, walletCode]);

    const useGetPayLaterDetailsReturnObj = useMemo(() => {
        return {
            payLaterMethodData,
        };
    }, [payLaterMethodData]);

    return useGetPayLaterDetailsReturnObj;
};
